import { render } from "./Address.vue?vue&type=template&id=5ee36830&bindings={\"onAdd\":\"setup\",\"onEdit\":\"setup\",\"select\":\"setup\"}"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script